import styled from 'styled-components';

import { PayrunAssignee } from '@xemplo/gp-types';
import { BodySmallRegular, BodyXSmallMedium, Colour } from '@xemplo/style-constants';
import { XemploTable } from '@xemplo/table';
import { Tooltip } from '@xemplo/tooltip';

export const Table = styled(XemploTable<PayrunAssignee>)`
  border-radius: 8px;

  margin-bottom: 32px;
  ${BodySmallRegular};
  color: ${Colour.Gray[600]};

  & .action-bar-container {
    display: none;
  }

  table {
    background: transparent;

    thead {
      border: none;
      color: ${Colour.Gray[700]};
      ${BodyXSmallMedium};
    }

    tbody {
      background: transparent;

      tr {
        box-sizing: border-box;
        border: 1px solid ${Colour.Dark[5]};
        background: ${Colour.Light[100]};
      }
    }
  }
`;
export const InlineTooltip = styled(Tooltip)`
  display: inline-block;
`;
